/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Button } from "@nordcloud/gnui";
import FlexContainer from "../Styled/FlexContainer";

type Props = {
  onCancel: () => void;
  submitText?: string;
  submitLoading?: boolean;
  submitEnabled?: boolean;
};

function SidebarFormButtons(props: Props) {
  return (
    <FlexContainer>
      <Button
        type="submit"
        initialState={props.submitLoading ? "loading" : ""}
        disabled={props.submitEnabled === false}
      >
        {props.submitText || "Save"}
      </Button>

      <Button
        severity="medium"
        css={{ marginLeft: "auto" }}
        onClick={props.onCancel}
      >
        Cancel
      </Button>
    </FlexContainer>
  );
}

export { SidebarFormButtons };
